import { Components, Theme } from '@mui/material/styles';

export const muiListItemIconOverride: Components<Theme>['MuiListItemIcon'] = {
  styleOverrides: {
    root: {
      minWidth: 24,
    },
  },
};
